module.exports = __webpack_public_path__ + "assets/img/noData.eddd9263.png";